
import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuGroup,
} from '@/components/ui/dropdown-menu';

interface NavSectionProps {
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
  labelColor: string;
  children: React.ReactNode;
}

const NavSection = ({ icon, label, isActive, labelColor, children }: NavSectionProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          className={`text-sm font-medium transition-colors ${
            isActive ? "text-blue-600" : "text-black hover:text-blue-600 dark:text-gray-200"
          }`}
        >
          {React.cloneElement(icon as React.ReactElement, { 
            className: `h-4 w-4 mr-1 ${isActive ? "text-blue-600" : labelColor}` 
          })}
          {label}
          <ChevronDown className="h-3 w-3 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>{label} Management</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          {children}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NavSection;
